import React, { Component } from 'react'
import { connect } from 'react-redux'
import TextField from 'material-ui/TextField'
import { createSearchAction, getSearchSelectors } from 'redux-search'

import dataActions from 'actions/dataActions'
import { selector } from 'selectors/search'


let select = (state, props) => {
	let {
	  text
	} = getSearchSelectors({
	  resourceName: props.entity,
	  resourceSelector: selector
	})
	return (state, props) => ({
		text: text(state)
	})
}

let mapDispatchToProps = (dispatch, props) => {
	// console.log('mapDispatchToProps', props);
	let search = createSearchAction(props.entity)
	return (dispatch) => ({
		search: (term) => dispatch(search(term))
	})
}

export class Search extends Component{
	render(){
		let { props } = this
		return(
			<div style={{
				 ...props.style,
					border: "1px solid #FFF"
				  , borderRadius: "6px"
				  , backgroundColor: "#3cd2ae"
				  , height: "40px"
				  , padding: "0px 5px 4px 0px"
				}}
			>
				<TextField
					key = {props.text}
					id = 'search-input'
					spellCheck="false"
					defaultValue = {props.text}
					style={{width: "calc(100% - 32px)"
						, position: "relative"
						, left: "8px"
						, top: "-4px"
						, float: "left"
					}}
					inputStyle = {{
						color: "#FFF"
					}}
					underlineShow = {false}
					onBlur = {(evt) => {
							props.search(evt.target.value)
						}
					}
					onKeyUp = {(evt) => {
							if (evt.target.value == props.text){
								return
							}
							if(evt.key == 'Enter') {
								props.search(evt.target.value)
							}
							else {
								var v = evt.target.value
								setTimeout(() => {
									props.search(v,v.length)
									console.log(v, );
									document.getElementById('search-input').focus()
									document.getElementById('search-input').setSelectionRange(v.length, v.length)
								}, 10)
							}
						}
					}
				/>
				<img src={'/' + process.env.REACT_APP_NAME + "/static/img/res/menu_magnify.png"}
					style={{
						height:"24px"
					  , cursor: "pointer"
					  , position: "relative"
					  , left: "12px"
					  , top: "8px"
					}}
				/>
			</div>
		)
	}
}
export default connect(select, mapDispatchToProps)(Search)



// WEBPACK FOOTER //
// ./src/components/Search.js